import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
var firebaseConfig = {
    apiKey: "AIzaSyDqxMOJJwik3fXFqxXFrZcq2Fl36eEbdEo",
    authDomain: "clinic-website-edf89.firebaseapp.com",
    projectId: "clinic-website-edf89",
    storageBucket: "clinic-website-edf89.appspot.com",
    messagingSenderId: "163796139357",
    appId: "1:163796139357:web:000341bbbd23490be0fcb4"
};
    
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app)
const database = getFirestore(app);
export default db;
